import Home from "../home/Home"
import React from "react"


const Wrapper = () => {
  return (
    <div>
      <Home/>
    </div>
  )
}

export default Wrapper
